// Certification badge artwork, shared by every surface that shows credentials
// (product results, the comparison report). Keyed by the cert id stored in
// social_impact — product ids come from ./productCerts, business ids from
// BUSINESS_CERT_LABELS in ProductResults.js / server/pdfGenerator.js.

import bcorpLogo from "../assets/certs/bcorp.png";
import amforiLogo from "../assets/certs/amfori.png";
import smetaLogo from "../assets/certs/smeta.png";
import sa8000Logo from "../assets/certs/sa8000.png";
import wrapLogo from "../assets/certs/wrap.png";
import fscLogo from "../assets/certs/FSC.png";
import fscPefcLogo from "../assets/certs/fsc-pefc.png";
import abaLogo from "../assets/certs/ABA Certified.png";
import iso45001Logo from "../assets/certs/iso45001.png";
import iso14001Logo from "../assets/certs/iso14001.png";
import iso9001Logo from "../assets/certs/iso9001.png";
import climateActiveCarbonNeutralLogo from "../assets/certs/climateactiveCarbonNeutral.png";
import climateActiveBronzeLogo from "../assets/certs/BronzeEv.png";
import climateActiveSilverLogo from "../assets/certs/SilverEV.png";
import climateActiveGoldLogo from "../assets/certs/GoldEV.png";
import climateActivePlatinumLogo from "../assets/certs/PlatinumEV.png";
import oekoTexLogo from "../assets/certs/oeko-tex.png";
import climateActiveLogo from "../assets/certs/climateactive.png";
import ecovadisLogo from "../assets/certs/ecovadis.png";
import apcoMemberLogo from "../assets/certs/APCO Member.png";
import sedexMemberLogo from "../assets/certs/Sedex Member.png";
import snMemberLogo from "../assets/certs/SN Member.png";
import snRegisteredLogo from "../assets/certs/SN Registered.png";
import snCertifiedLogo from "../assets/certs/SN Certified.png";

export const CERT_LOGOS = {
  bcorp: bcorpLogo,
  bsci: amforiLogo,
  sedex: smetaLogo,
  sa8000: sa8000Logo,
  wrap: wrapLogo,
  fsc: fscLogo,
  fsc_pefc: fscPefcLogo,
  aba: abaLogo,
  iso45001: iso45001Logo,
  iso14001: iso14001Logo,
  iso9001: iso9001Logo,
  oeko_tex: oekoTexLogo,
  climateactive: climateActiveLogo,
  ecovadis: ecovadisLogo,
  climate_active_carbon_neutral: climateActiveCarbonNeutralLogo,
  ecovadis_bronze: climateActiveBronzeLogo,
  ecovadis_silver: climateActiveSilverLogo,
  ecovadis_gold: climateActiveGoldLogo,
  ecovadis_platinum: climateActivePlatinumLogo,
  apco_member: apcoMemberLogo,
  sedex_member: sedexMemberLogo,
  supply_nation_member: snMemberLogo,
  supply_nation_registered: snRegisteredLogo,
  supply_nation_certified: snCertifiedLogo,
};

// NO_FILE_CERTS moved to ./productCerts, alongside the cert ids and labels it
// describes — this module is artwork only.

// Fallback mark for credentials with no artwork on file.
export function certMonogram(label) {
  const words = String(label || "").trim().split(/\s+/);
  const mono =
    words.length >= 2
      ? (words[0][0] || "") + (words[1][0] || "")
      : String(label || "").slice(0, 2);
  return mono.toUpperCase();
}
